<div class="detail-page">
  <form (ngSubmit)="save()" novalidate>
    <div style="max-width: 450px">
      <h3>{{ 'maksut.toimittajat.perustiedot' | translate | async }}</h3>
      <mat-form-field>
        <mat-label>{{ 'maksut.toimittajat.nimi' | translate | async }}</mat-label>
        <input matInput [formField]="lomake.nimi" />
        <mat-error>{{ fieldErrors().nimi }}</mat-error>
      </mat-form-field>
      @if (maksutPuoli) {
        <mat-form-field>
          <mat-label>{{ 'maksut.toimittajat.maksun-saaja' | translate | async }}</mat-label>
          <input matInput [formField]="lomake.maksunSaaja" />
          <mat-error>{{ fieldErrors().maksunSaaja }}</mat-error>
        </mat-form-field>
      }
      <mat-form-field>
        <mat-label>{{ 'maksut.toimittajat.ytunnus' | translate | async }}</mat-label>
        <input matInput [formField]="lomake.ytunnus" />
        <mat-error>{{ fieldErrors().ytunnus }}</mat-error>
      </mat-form-field>
      @if (muutTunnisteet().length) {
        <div class="gray-text muut-tunnisteet">{{ 'maksut.toimittajat.muut-tunnisteet' | translate: { tunnisteet: muutTunnisteet().join(', ') } | async }}</div>
      }

      @if (maksutPuoli) {
        <div class="ytj-taydennys">
          <button mat-button class="secondarybutton" type="button" (click)="taydennaYtjsta()" [disabled]="ytjHakuKaynnissa()">
            {{ 'maksut.toimittajat.taydenna-ytj' | translate | async }}
          </button>
          @if (ytjViesti()) {
            <div [class.error-text]="ytjVirhe()">{{ ytjViesti() }}</div>
          }
        </div>

        <mat-form-field>
          <mat-label>{{ 'maksut.toimittajat.katuosoite' | translate | async }}</mat-label>
          <input matInput [formField]="lomake.katuosoite" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'maksut.toimittajat.postinro' | translate | async }}</mat-label>
          <input matInput [formField]="lomake.postinro" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'maksut.toimittajat.postitmp' | translate | async }}</mat-label>
          <input matInput [formField]="lomake.postitmp" />
        </mat-form-field>

        <!-- Toimittajan IBANit-->
        <div style="margin-top: 20px; margin-bottom: 20px">
          <h3>{{ 'maksut.toimittajat.tilit' | translate | async }}</h3>

          <!-- Table header -->
          <div style="display: flex; gap: 8px; padding: 8px 8px 4px 8px; font-size: 13px; color: #666; border-bottom: 1px solid #ddd; margin-bottom: 8px">
            <div style="width: 60px; text-align: center; flex-shrink: 0">{{ 'maksut.toimittajat.oletus' | translate | async }}</div>
            <div style="flex: 2">{{ 'laskuasetukset.iban' | translate | async }}</div>
            <div style="flex: 1">{{ 'laskuasetukset.bic' | translate | async }}</div>
            <div style="width: 50px; flex-shrink: 0"></div>
          </div>

          <mat-radio-group [value]="annaOletusIbanIndex()" (change)="asetaOletusIbaniksi($event)">
            <div>
              @for (rivi of lomake.ibans; track rivi; let i = $index) {
                <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 6px; padding: 4px 8px">
                  <div style="width: 60px; display: flex; justify-content: center; flex-shrink: 0">
                    <mat-radio-button [value]="i"></mat-radio-button>
                  </div>
                  <mat-form-field style="flex: 2">
                    <input matInput [formField]="rivi.iban" (input)="ibanMuuttui($any($event.target).value, rivi.bic)" placeholder="IBAN" />
                    @if (onkoVirhe(rivi.iban, 'iban')) {
                      <mat-error>{{ 'maksut.muokkaa.validation.iban.invalid' | translate | async }}</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field style="flex: 1">
                    <input matInput [formField]="rivi.bic" placeholder="BIC" />
                    @if (onkoVirhe(rivi.bic, 'bic')) {
                      <mat-error>{{ 'maksut.muokkaa.validation.bic.invalid' | translate | async }}</mat-error>
                    }
                  </mat-form-field>
                  <div style="width: 50px; display: flex; justify-content: center; flex-shrink: 0">
                    <button mat-icon-button type="button" (click)="poistaIban(i)" color="warn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </mat-radio-group>

          <button mat-button class="primarybutton" type="button" (click)="lisaaIban()" color="primary" style="margin-top: 8px">
            <mat-icon>add</mat-icon>
            {{ 'maksut.toimittajat.lisaa-tili' | translate | async }}
          </button>
        </div>
      }

      <div style="display: flex; justify-content: space-between">
        <button class="secondarybutton" mat-button [routerLink]="_basePath" type="button">{{ 'yleiset.peruuta' | translate | async }}</button>
        @if (toimittaja()?.avain && toimittaja()?.avain !== 'uusi') {
          <button class="secondarybutton" mat-button (click)="poista()" type="button">{{ 'yleiset.poista' | translate | async }}</button>
        }
        <button class="primarybutton" mat-button (click)="save()" type="button">{{ 'yleiset.tallenna' | translate | async }}</button>
      </div>
    </div>
  </form>
</div>
